<template>
  <div class="main-container inventory-table-height">
    <div style="width: 100%;">
      <vk-modal :show.sync="showInventoryApprove">
        <vk-modal-close @click="showInventoryApprove = false"></vk-modal-close>
        <vk-modal-title>{{currentDeviceRequest?`${currentDeviceRequest.name}`:"-"}}</vk-modal-title>
        <h3>{{currentDeviceRequest["deviceRequest"]? `${currentDeviceRequest["deviceRequest"]['deviceType']['name']} (${currentDeviceRequest["deviceRequest"]['paymentModel']})`:'-'}}</h3>
        <hr />
        <!-- <div>{{currentDeviceRequest?currentDeviceRequest:"-"}}</div> -->
        <div
          style="flex: 1; display: flex; align-items: center; flex-flow: column; justify-content: center; padding: 10px;"
        >
          <!-- {{currentDeviceRequest["deviceRequest"]? currentDeviceRequest["deviceRequest"]['installationComponents']:'-'}} -->
          <div
            class="componentInfo"
            v-for="(componentInfo,index)  in (BOQ)"
            :key="`componentInfo_${index}`"
          >
            <b>
              {{ componentInfo['componentItems']['name'] }}
              (Available: {{_printTotalAvailableComponents(componentInfo, inventoryCount)}})
            </b>
            <span>{{componentInfo['quantity']}}</span>
          </div>
        </div>

        <div class="text-center">
          <can I="am" a="finance">
            <button
              class="btn btn-primary"
              :disabled="_shouldDisableApproveButton(currentDeviceRequest.deviceRequest, inventoryCount)"
              @click="submitRequest"
            >Approve inventory request</button>
          </can>
        </div>
      </vk-modal>
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="columns"
        :rows="deviceRequests"
        :search-options="{enabled: true,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
        :lineNumbers="true"
      >
        <!-- styleClass="table table-striped col-md-12" -->
        <template slot="table-row" slot-scope="props">
          <span
            v-if="props.column.field == 'full_name'"
          >{{ props.row.deviceRequest.user? `${props.row['name'] }`:'--' }}</span>
          <span
            v-if="props.column.field == 'installation_name'"
          >{{props.row['installationName'] ? `${props.row['installationName'] } ` : props.row.deviceRequest.user?`${props.row.deviceRequest.user['firstName'] } ${ props.row.deviceRequest.user['lastName']}`:'--' }}</span>

          <span
            v-else-if="props.column.field == 'email'"
          >{{ props.row.deviceRequest.user? `${props.row.deviceRequest.user['email'] } ` :'--' }}</span>
          <span
            v-else-if="props.column.field == 'CID'"
          >{{ props.row? `${props.row['CID'] } ` :'--' }}</span>
          <span
            v-else-if="props.column.field == 'user.phone'"
          >{{ props.row.deviceRequest.user? `${props.row.deviceRequest.user['phoneNumber'] } ` :'--' }}</span>
          <span
            v-else-if="props.column.field == 'deviceType.name'"
          >{{ props.row.deviceRequest.deviceType? `${props.row.deviceRequest.deviceType['name'] } ` :'--' }}</span>
          <span
            v-else-if="props.column.field == 'gender'"
          >{{(props.row.deviceRequest.gender+"" === "0")?'Female':'Male'}}</span>
          <span v-else>{{props.row.deviceRequest[props.column.field]}}</span>
          <span v-if="props.column.field == 'actions'" class="fancy">
            <can I="manage" a="installation">
              <!-- @click="scheduleInstalation(props.row.deviceRequest)" -->
              <!-- <router-link :to="`/installation/inventory/${props.row.id}`"> -->
              <b-button
                size="md"
                variant="info"
                style="margin-top: 12px;"
                @click="showApprovalModal(props.row)"
              >
                View &nbsp;
                <!-- <span class="fa fa-calendar"></span> -->
              </b-button>

              <!-- </router-link> -->
            </can>
          </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
import Autocomplete from "../../utils/Autocomplete";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ongoingInstalation",
  components: {
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    Autocomplete
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      currentDeviceRequest: {},
      showInventoryApprove: false,
      componentId: null,
      componentTypeId: null,
      BOQ: [],
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null
      },
      inventoryCount: {
        // 1: 0,
        // 2: 0,
        // ...
      },
      deviceRequests: [],
      componentOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ],
      dataParams: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [
        {
          label: "Customer Name",
          field: "full_name",
          sortable: "true"
        },
        {
          label: "Installation Name",
          field: "installation_name",
          filterable: true,
          sortable: "true"
        },
        {
          label: "Customer ID",
          field: "CID",
          sortable: "true"
        },
        {
          label: "Phone Number",
          field: "user.phone",
          filterable: true,
          sortable: "true"
        },
        // {
        //   label: 'Installation Address',
        //   field: 'address',
        //   filterable: true,
        // },
        {
          label: "Desired Bundle",
          field: "deviceType.name",
          filterable: true,
          sortable: "true"
        },
        {
          label: "Actions",
          field: "actions",
          sortable: "true"
        }
      ],
      rows: [],
      reqSuccess: false
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  methods: {
    submitRequest(event) {
      event.preventDefault();
      //console.log(this.currentDeviceRequest)
      let scope = {
        status: "scheduled",
        approvedAt: new Date(),
        approvedById: this.getUserSession.id
      };
      //console.log(scope)
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.patch(
        `/device_requests/${this.currentDeviceRequest.deviceRequestId}`,
        { status: 4 }
      )
        .then(response => {
          HTTP.patch(
            `/installations/${this.currentDeviceRequest.id}`,
            scope
          ).then(response => {
            const Response = response.data;
            console.log(response.data);
            if (Response) {
              container.showSuccessMsg({
                message: "Inventory request approved"
              });
              container.showInventoryApprove = false;
              // container.fetchDeviceRequests();
              container.$router.push({
                name: "devices",
                params: {
                  activetab: "inventory_request"
                }
              });
              container.$router.go();
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.showErrorMsg({
            message: "error occured"
          });
        });
    },
    validateRequestForm() {
      for (let [field, value] of Object.entries(this.requestForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    showApprovalModal(row) {
      console.log(row);
      this.currentDeviceRequest = row;
      if (row.BOQ) {
        this.BOQ = JSON.parse(row["BOQ"]);
      } else {
        this.BOQ = row.deviceRequest.installationComponents;
      }
      this.showInventoryApprove = true;

      // console.log(this.currentDeviceRequest);
      // console.log(this.BOQ);
      // this.BOQ = JSON.parse(this.currentDeviceRequest['BOQ']
      // let boq=JSON.parse(this.currentDeviceRequest['BOQ']);

      // this.currentDeviceRequest["BOQ"] = boq;
      // if (this.currentDeviceRequest['BOQ'] == null){
      //   this.currentDeviceRequest =
      // }
      // console.log(this.curre);

      // console.log(this.getUserSession.id)
    },
    scheduleInstalation(installationObj) {
      this.$router.push({
        name: "instalationSchedule",
        params: {
          Installation: installationObj
        }
      });
    },

    fetchInventoryCounts(array) {
      // this accepts an array
      const HTTP = this.$httpUtils.instance;
      const context = this;
      const componentIds = JSON.stringify(this._formatArrayInput(array));
      HTTP.get(
        `/inventories/?filter={"where": {"status": "0", "componentId": {"inq" : ${componentIds}}}}`
      )
        .then(response => {
          // @todo: this should be extrated to its function
          const totalItems = response.data.reduce((result, item) => {
            const itemComponentId = item.componentId;
            return {
              ...result,
              [itemComponentId]: result[itemComponentId]
                ? result[itemComponentId] + 1
                : 1
            };
          }, {});

          context.inventoryCount = { ...totalItems };
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    _formatArrayInput(arrayInput) {
      // my input looks like "[solar_panel_2, battery_1]"
      // output should return => JSON.stringify(["1","2","3"])
      if (arrayInput.length < 1) {
        console.log("nothing in array");
        return;
      }

      return arrayInput.map(item => {
        const splitedResult = item.split("_");
        // select last item in array
        return splitedResult[splitedResult.length - 1];
      });
    },
    _convertIntKeyToNamedValues(value) {
      switch (value) {
        case 1:
          return "batteries";
        case 2:
          return "inverters";
        case 3:
          return "solar_panels";
        default:
          return "undefined_0";
      }
    },
    _countOrReturnZero(value) {
      if (!value) {
        return 0;
      }
      return value;
    },
    fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/components/${selectedCompId}/componentTypes`;
        HTTP.get(url)
          .then(response => {
            const componentList = response.data;
            componentList.filter(x => {
              x.value = x.id;
              x.text = x.name;
            });
            componentList.unshift({
              value: null,
              disabled: true,
              text: "Please component type"
            });

            context.componentTypeOptions = componentList;
            context.componentTypeId = null;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },
    fetchComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/components/", {})
        .then(components => {
          const componentFetch = components.data;
          componentFetch.filter(x => {
            x.value = x.id;
            x.text = x.name;
          });

          componentFetch.unshift({
            value: null,
            disabled: true,
            text: "Select Component"
          });
          container.componentOptions = componentFetch;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formatDate(date) {
      var date = new Date(date); //or your date here
      return (
        date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate()
      );
    },
    formatTime(date) {
      var date = new Date(date); //or your date here
      return (
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
      );
    },
    fetchData(d) {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(
        `/device_requests/?filter={"include": ["user","deviceType"]}`,
        {}
      ).then(components => {
        const componentFetch = components.data;
        this.dataParams = componentFetch;
      });
    },
    fetchDeviceRequests() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      let filter = {
        order: "id DESC",
        where: { status: "requested" },
        include: {
          deviceRequest: [
            "user",
            "deviceType",
            { installationComponents: ["componentItems"] }
          ]
        }
      };
      // console.log(JSON.stringify(filter));
      HTTP.get(
        // `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 3}, "order": "id DESC" }`,
        `/installations/?filter=${JSON.stringify(filter)}`,
        {}
      ).then(rolesdata => {
        // console.log(JSON.stringify(rolesdata.data))

        container.deviceRequests = rolesdata.data.filter(x => {
          if (x.deviceRequest) {
            return true;
          } else {
            console.log(x);
          }
        });
        console.log(container.deviceRequests);
        this._fetchAndParseInventoryItems(container.deviceRequests);
      });
    },
    _fetchAndParseInventoryItems(items) {
      const result = items.reduce((total, item) => {
        const _inventoryNames = this._compileInventoryComponentNameOnEachInstallation(
          item
        );
        return [...total, ..._inventoryNames];
      }, []);
      const _inventoryItems = this._removeArrayDuplicates(result);
      const _inventoryCounts = this.fetchInventoryCounts(_inventoryItems);
    },
    _removeArrayDuplicates(array) {
      if (array.length > 0) {
        return array.reduce((total, single) => {
          return total.includes(single) ? total : [...total, single];
        }, []);
      }
    },
    _printTotalAvailableComponents(selectedComponent, recognizedInventories) {
      // (selectedComponent.componentTypeId in recognizedInventories) ==> nice but not readable
      const selected = selectedComponent.componentTypeId;
      const quantity = selectedComponent.quantity;
      const total = recognizedInventories[selected];
      if (recognizedInventories.hasOwnProperty(selected)) {
        if (total < quantity) {
          return total + " - FIX: limited quantity in stock";
        }
        return total;
      }
      return 0 + " - FIX: limited quantity in stock";
    },
    _shouldDisableApproveButton(selectedComponent, recognizedInventories) {
      // return false;
      try {
        let result = false;
        const components = selectedComponent.installationComponents;
        components.forEach(item => {
          const quantity = item.quantity;
          const componentId = item.componentTypeId;
          if (recognizedInventories.hasOwnProperty(componentId)) {
            const total = recognizedInventories[componentId];
            if (total < quantity) {
              result = true; // if total is less than quantity, yes, shouldDisableApproveButton;
            }
          } else {
            // if an item doesn't exist in inventory count
            // that's an automatic 0 total
            result = true;
          }
        });
        return result; //if all goes well, return false (i.e don't disable approve button)
      } catch (error) {}

      return true;
    },
    _compileInventoryComponentNameOnEachInstallation(installations) {
      const inputs = installations.deviceRequest.installationComponents;
      if (inputs) {
        return inputs.reduce((total, item) => {
          const jointName =
            item.componentItems.name + "_" + item.componentTypeId;
          return total.includes(jointName) ? total : [...total, jointName];
        }, []);
      }
    }
  },
  mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
    this.fetchDeviceRequests();
  }
};
</script>

<style>
.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.p-trial-period-expired__upgrade .form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}

.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  color: #269af1;
  /* height: 100px; */
}

.custom-modal__body {
  padding: 40px;
  text-align: left;
}

.test-basic__format {
  font-size: 16px;
  color: #939daa;
}

.test-basic__format span {
  font-weight: 800;
  color: #269af1;
}

.fancy a {
  color: #424242 !important;
}
.componentInfo {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #eee;
  padding: 10px;
}
.inventory-table-height {
  height: calc(100vh - 280px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/instalation/inventoryRequest.vue